// Property registry — the single place that lists all properties.
//
// TO ADD A NEW PROPERTY:
//   1. Create public/images/<your-slug>/ and add gallery-1.jpg ... gallery-4.jpg
//   2. Create src/data/properties/<your-slug>.json (copy an existing file as a template)
//   3. import it below and add it to the PROPERTIES_RAW array (position = display order)
// No UI/component changes are required.

import { propertyImage } from "@/lib/images";

import geetasLuxuria from "./geetas-luxuria.json";
import krishaResidency from "./krisha-apartment.json";
import vitthalHomestay from "./vitthal-homestay.json";
import shriKashiDham from "./shri-kashi-dham-dormitory.json";

const PROPERTIES_RAW = [
  geetasLuxuria,
  krishaResidency,
  vitthalHomestay,
  shriKashiDham,
];

// Resolve image filenames -> full public paths so components can use
// `property.cover` and `property.gallery` directly.
const hydrate = (p) => ({
  ...p,
  cover: propertyImage(p.images.folder, p.images.cover),
  gallery: p.images.gallery.map((file) => propertyImage(p.images.folder, file)),
});

export const PROPERTIES = PROPERTIES_RAW.map(hydrate);

export const getProperty = (slug) => PROPERTIES.find((p) => p.slug === slug);
